import { Form, Input, Modal } from 'antd';
import React, { useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { log } from 'utils';

const ModalChildCategoryForm = ({
  category,
  setCategory,
  visible,
  isEditing,
  onCancel,
  onCreate,
}) => {
  const [form] = Form.useForm();

  const { loading } = useSelector(
    (state) => ({
      loading: state.childComponentCategory.loading,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({
        name: category.name,
        description: category.description,
      });
    }
  }, [visible, category, form]);

  const onSave = (values) => {
    onCreate({
      ...category,
      id: category._id,
      name: values.name,
      description: values.description,
    });
    form.resetFields();
  };

  return (
    <Modal
      visible={visible}
      className="adsign-modal"
      title={isEditing ? 'Edit Category' : 'Create New Category'}
      closeIcon={<i className="feather-x" />}
      okText="Submit"
      confirmLoading={loading}
      okButtonProps={{
        className: 'button-submit',
      }}
      cancelButtonProps={{
        className: 'button-cancel',
      }}
      onCancel={() => {
        onCancel();
        form.resetFields();
      }}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            onSave(values);
          })
          .catch((info) => {
            log('Validate Failed:', info);
          });
      }}
    >
      <Form
        layout="vertical"
        form={form}
        initialValues={{
          name: category.name,
          description: category.description,
        }}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: 'Please enter category name' }]}
        >
          <Input placeholder="Enter Category name" />
        </Form.Item>

        <Form.Item label="Description" name="description">
          <Input.TextArea rows={4} placeholder="Description" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalChildCategoryForm;
